import { createAction, createSlice } from "@reduxjs/toolkit";

export const saveCustomActionRequest = createAction("workflowCustomAction/saveCustomActionRequest");

const initialState = {
  response: null,
  loading: false,
  error: null
};

const workflowCustomActionSlice = createSlice({
  name: "workflowCustomAction",
  initialState,
  reducers: {
    saveCustomActionStart(state) {
      state.loading = true;
      state.error = null;
    },
    saveCustomActionSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    saveCustomActionFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearCustomActionSaveState(state) {
      state.response = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  saveCustomActionStart,
  saveCustomActionSuccess,
  saveCustomActionFailure,
  clearCustomActionSaveState
} = workflowCustomActionSlice.actions;

export default workflowCustomActionSlice.reducer;
